import { useQuery, useQueryClient } from 'react-query';

export default function useViewerList(liveStreamId: number) {
  const queryClient = useQueryClient();
  const { data: viewerList }: any = useQuery(['viewerList', liveStreamId], () =>
    queryClient.getQueryData(['viewerList', liveStreamId])
  );
  return { viewerList };
}
